export default "__VITE_ASSET__DMH8XG2G__"